import React from "react";
import { Box } from "@mui/material";
import { useModel } from "hooks/useModel";
import moment from "moment";
import styles from "./ChatList.module.scss";
import ChatListContentItem from "./ChatListContentItem";

const ChatListContent = () => {
  const { chatlist } = useModel("aichat");

  return (
    <>
      {chatlist
        .filter((i) => moment(i?.lastModifiedDate || i?.createdDate).isSame(moment(), "day"))
        .map((i, index) => {
          if (index === 0) {
            return (
              <div key={i.id}>
                <Box className={styles.subtitle}>Today</Box>
                <ChatListContentItem
                  item={i}
                  index={index}
                />
              </div>
            );
          }
          return (
            <ChatListContentItem
              key={i.id}
              item={i}
              index={index}
            />
          );
        })}
      {chatlist
        .filter((i) => !moment(i?.lastModifiedDate || i?.createdDate).isSame(moment(), "day"))
        .map((i, index) => {
          if (index === 0) {
            return (
              <div key={i.id}>
                <Box className={styles.subtitle}>Earlier</Box>
                <ChatListContentItem
                  item={i}
                  index={index}
                />
              </div>
            );
          }
          return (
            <ChatListContentItem
              key={i.id}
              item={i}
              index={index}
            />
          );
        })}
    </>
  );
};

export default ChatListContent;
